import { WarehouseGridSchema } from "@redotech/redo-fulfillment-wms-common/schema/warehouse-grid";
import { locationIdFormat } from "@redotech/redo-ids-cockroach";
import * as z from "zod";

export const upsertWarehouseLayout = {
  name: "upsertWarehouseLayout" as const,
  input: z.object({
    layoutId: z.string().nullish(),
    crdbLocationId: locationIdFormat.schema.nullish(),
    warehouseGrid: WarehouseGridSchema,
    expectedUpdatedAt: z.date().nullish(),
  }),
  output: z.object({
    success: z.boolean(),
    layoutId: z.string().nullish(),
    updatedAt: z.date().nullish(),
    versionConflict: z.boolean().optional(),
  }),
};
